'use client'

import { useState, useTransition } from 'react'
import { Bookmark } from 'lucide-react'
import { toggleSaveJob } from '../_actions/saved-job-actions'

interface SaveJobButtonProps {
  jobId: string
  initialSaved?: boolean
}

export function SaveJobButton({ jobId, initialSaved = false }: SaveJobButtonProps) {
  const [saved, setSaved] = useState(initialSaved)
  const [isPending, startTransition] = useTransition()

  const handleToggle = () => {
    // Optimistic update
    setSaved((prev) => !prev)

    startTransition(async () => {
      const result = await toggleSaveJob(jobId)
      if (result.success && result.data) {
        setSaved(result.data.saved)
      } else {
        // Revert on failure
        setSaved((prev) => !prev)
      }
    })
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        handleToggle()
      }}
      disabled={isPending}
      className="inline-flex items-center justify-center rounded-[var(--radius-md)] p-1.5 transition-colors hover:bg-[var(--color-bg-elevated)]"
      aria-label={saved ? 'Unsave job' : 'Save job'}
      title={saved ? 'Unsave job' : 'Save job'}
    >
      <Bookmark
        className="h-4 w-4"
        style={{
          color: saved ? 'var(--color-accent)' : 'var(--color-text-muted)',
          fill: saved ? 'var(--color-accent)' : 'none',
        }}
      />
    </button>
  )
}
